import { render, staticRenderFns } from "./CampaignConnectChannelModal.vue?vue&type=template&id=465e6913"
import script from "./CampaignConnectChannelModal.vue?vue&type=script&lang=js"
export * from "./CampaignConnectChannelModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignConnectChannelModal.vue?vue&type=style&index=0&id=465e6913&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports